import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../rootReducer";
import { DocumentStakeholder } from "../../../@types/documentStakeholder";
import axios from "axios";
import axiosInstance from "../../../utils/axiosConfig";

export const moveStakeholderUp = createAsyncThunk(
  "documentShow/moveStakeholderUp",
  async (stakeholder: DocumentStakeholder, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const signers = state.documentShow.signers;
      // const { id: idDocument } = state.documentShow.document;

      let previousStakeholder = signers.find(
        ({ order }) => (stakeholder?.order || 0) - 1 === order
      );

      if (!previousStakeholder) throw new Error("El firmante no existe.");

      // stakeholder.order && stakeholder.order--;
      const currentOrder = stakeholder.order && stakeholder.order - 1;

      const firstResponse = await axiosInstance.patch(
        `${api.baseURL}documentstakeholder/${stakeholder.id}`,
        {
          order: currentOrder,
        }
      );

      // previousStakeholder?.order && previousStakeholder.order++;
      const previousOrder = previousStakeholder.order && previousStakeholder.order + 1;

      const secondResponse = await axiosInstance.patch(
        `${api.baseURL}documentstakeholder/${previousStakeholder?.id}`,
        {
          order: previousOrder,
        }
      );
      const first: DocumentStakeholder = firstResponse.data;
      const second: DocumentStakeholder = secondResponse.data;

      return [first, second];
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
